import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const { refresh } = useAuth();
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) { nav("/login"); return; }
    (async () => {
      try {
        await api.post("/auth/emergent-session", { session_id: sessionId });
        window.history.replaceState({}, "", "/dashboard");
        await refresh();
        nav("/dashboard");
      } catch { nav("/login"); }
    })();
  }, [nav, refresh]);
  return <div className="min-h-[50vh] flex items-center justify-center text-neutral-500" data-testid="auth-callback">Signing you in…</div>;
}
